import React, { useEffect, useState } from "react";
import { Globe2 } from "lucide-react";
import { api } from "../../../lib/api";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
const monthName = (p) => (p ? new Date(`${p}-01T00:00:00Z`).toLocaleDateString("en-IN", { month: "long", year: "numeric" }) : "");

const Part = ({ label, part, testid }) => (
  <div className="rounded-xl bg-slate-50 px-3 py-2" data-testid={testid}>
    <div className="text-[10px] font-mono uppercase tracking-wider text-slate-500">{label}</div>
    <div className="text-sm font-semibold text-slate-900">{part.credits} credits</div>
    <div className="text-[11px] text-slate-500">{part.count} charge{part.count === 1 ? "" : "s"}</div>
  </div>
);

export const DomainEarningsCard = ({ refreshKey }) => {
  const [e, setE] = useState(null);
  useEffect(() => { api.adminDomainEarnings().then(setE).catch(() => {}); }, [refreshKey]);
  if (!e) return null;
  return (
    <div className="mb-6 rounded-2xl border border-slate-200 bg-white p-5 flex flex-col lg:flex-row lg:items-center gap-5" data-testid="domain-earnings-card">
      <div className="flex items-start gap-3 flex-1 min-w-0">
        <span className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0"><Globe2 size={18} /></span>
        <div>
          <div className="text-xs font-mono uppercase tracking-wider text-slate-500">Domain earnings · {monthName(e.period)}</div>
          <div className="mt-1 font-display text-3xl font-bold text-slate-900" data-testid="domain-earnings-credits">{e.month.credits} credits</div>
          <div className="text-xs text-slate-500" data-testid="domain-earnings-inr">≈ {inr(e.month.inr)} at ₹{e.credit_inr}/credit · from {e.month.domains} domain{e.month.domains === 1 ? "" : "s"}</div>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 lg:w-[520px]">
        <Part label="Setup fees" part={e.month.setup} testid="domain-earnings-setup" />
        <Part label="Monthly fees" part={e.month.monthly} testid="domain-earnings-monthly" />
        <div className="rounded-xl bg-slate-50 px-3 py-2" data-testid="domain-earnings-live">
          <div className="text-[10px] font-mono uppercase tracking-wider text-slate-500">Live now</div>
          <div className="text-sm font-semibold text-slate-900">{e.live_now} domain{e.live_now === 1 ? "" : "s"}</div>
          <div className="text-[11px] text-slate-500">{e.live_now * e.monthly_fee} credits next month</div>
        </div>
        <div className="rounded-xl bg-slate-50 px-3 py-2" data-testid="domain-earnings-all-time">
          <div className="text-[10px] font-mono uppercase tracking-wider text-slate-500">All time</div>
          <div className="text-sm font-semibold text-slate-900">{e.all_time.credits} credits</div>
          <div className="text-[11px] text-slate-500">≈ {inr(e.all_time.inr)}</div>
        </div>
      </div>
    </div>
  );
};

export default DomainEarningsCard;
